<template>
  <Content
    class="col-span-full"
    :showAdd="false"
    :showBreadcrumb="false"
    @loading="loading = $event"
  >
    <div
      class="mb-6 px-4 pt-7 pb-3 shadow-sm rounded-lg border border-gray-200"
    >
      <el-form
        :model="filterForm"
        label-position="top"
        ref="filterForm"
        class="grid md:grid-cols-12 gap-4"
      >
        <VehicleGroupSelect
          prop="company_vehicle.id"
          :model="selectedVehicles"
          @update="vehicleChange($event)"
          @blur="vehicleBlur"
          @clear="vehicleClear"
          :disabled="false"
          :multiple="true"
          :collapseTags="true"
          class="xl:col-span-3 md:col-span-4"
        />

        <VehicleTag
          @tags="tagChanged"
          @blur="tagBlur"
          @clear="tagClear"
          :value="selectedTags"
          class="xl:col-span-3 md:col-span-4"
        />

        <OrganizationSelect
          @organizations="organizationChanged"
          @blur="organizationBlur"
          @clear="organizationClear"
          :value="selectedOrganizations"
          class="xl:col-span-3 md:col-span-4"
        />
        <!-- <div class="flex items-center justify-end xl:col-span-3">
          <el-button type="info" @click="resetFilters" size="small">
            {{ $t('FILTER_RESET') || 'Reset Filters' }}
          </el-button>
        </div> -->
      </el-form>
    </div>
    <div class="grid md:grid-cols-12 gap-4">
      <!-- Loading Skeletons -->
      <div v-if="loading" class="xl:col-span-3 md:col-span-12">
        <SkeletonCardBox />
      </div>

      <!-- Actual Data -->

      <div
        v-if="!loading && stats && stats.maintenance"
        class="xl:col-span-3 md:col-span-12"
      >
        <CardBox :data="maintenanceEntries" :changes="maintenanceChanges" />
      </div>
      <div class="xl:col-span-6 md:col-span-12">
        <FleetUtilizationChart
          v-if="!loading && fleetUtilizationData"
          :data="fleetUtilizationData"
        />
        <div v-else-if="loading" class="rounded-lg border border-gray-200 p-6">
          <div class="">
            <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div class="h-64 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div class="xl:col-span-3 md:col-span-12">
        <CostManagementChart v-if="!loading && costData" :data="costData" />
        <div v-else-if="loading" class="rounded-lg border border-gray-200 p-6">
          <div class="">
            <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div class="h-64 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div class="xl:col-span-9 md:col-span-12">
        <FuelEfficiencyChart
          v-if="!loading && fuelEfficiencyData"
          :data="fuelEfficiencyData"
        />
        <div v-else-if="loading" class="rounded-lg border border-gray-200 p-6">
          <div class="">
            <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div class="h-64 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="xl:col-span-3 md:col-span-12">
        <SkeletonCardBox />
      </div>
      <div
        v-if="!loading && stats && stats.driver_behavior"
        class="xl:col-span-3 md:col-span-12"
      >
        <CardBox :data="behaviorEntries" :changes="driverChanges" />
      </div>

      <div class="xl:col-span-12 md:col-span-12">
        <DriversBehaviorChart
          v-if="!loading && driversBehaviorData"
          :data="driversBehaviorData"
        />
        <div v-else-if="loading" class="rounded-lg border border-gray-200 p-6">
          <div class="">
            <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div class="h-64 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div class="xl:col-span-6 md:col-span-12">
        <FenceEventsChart
          v-if="!loading && fenceEventsData"
          :data="fenceEventsData"
        />
        <div v-else-if="loading" class="rounded-lg border border-gray-200 p-6">
          <div class="">
            <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div class="h-64 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>

<script>
import {
  StatsReport,
  FuelsEfficiencies,
  FleetUtilizations,
  StatsCosts,
  StatsFences,
  StatsDriversBehaviours,
} from '@/api/dashboard-page'
import CardBox from './components/cardBox.vue'
import SkeletonCardBox from './components/SkeletonCardBox.vue'
import FuelEfficiencyChart from './components/FuelEfficiencyChart.vue'
import FleetUtilizationChart from './components/FleetUtilizationChart.vue'
import CostManagementChart from './components/CostManagementChart.vue'
import FenceEventsChart from './components/FenceEventsChart.vue'
import DriversBehaviorChart from './components/DriversBehaviorChart.vue'
import VehicleGroupSelect from '@/components/elements/VehicleGroupSelect.vue'
import VehicleTag from '@/components/elements/vehcileTag.vue'
import OrganizationSelect from '@/components/elements/organizationSelect.vue'

export default {
  data() {
    return {
      stats: null,
      search: '',
      loading: true,
      selectedRange: '30d',
      dateRange: null,
      selectedVehicles: [],
      selectedTags: [],
      selectedOrganizations: [],
      // Track previous values for comparison
      previousVehicles: [],
      previousTags: [],
      previousOrganizations: [],
      filterForm: {
        company_vehicle: { id: [] },
        company_vehicle_tags: [],
        organizations: [],
      },
      fuelEfficiencyData: null,
      fleetUtilizationData: null,
      costData: null,
      fenceEventsData: null,
      driversBehaviorData: null,
      rangeOptions: [
        { value: 'today', label: this.$t('TODAY') },
        { value: 'yesterday', label: this.$t('YESTERDAY') },
        { value: '30d', label: this.$t('LAST_30_DAYS') },
        { value: '3m', label: this.$t('THREE_MONTHS') },
        { value: '6m', label: this.$t('SIX_MONTHS') },
        { value: '12m', label: this.$t('TWELVE_MONTHS') },
      ],
    }
  },
  components: {
    CardBox,
    SkeletonCardBox,
    FuelEfficiencyChart,
    FleetUtilizationChart,
    CostManagementChart,
    FenceEventsChart,
    DriversBehaviorChart,
    VehicleGroupSelect,
    VehicleTag,
    OrganizationSelect,
  },
  computed: {
    behaviorEntries() {
      const behaviors = {
        number_of_harsh_acceleration:
          this.stats.driver_behavior.number_of_harsh_acceleration,
        number_of_harsh_braking:
          this.stats.driver_behavior.number_of_harsh_braking,
        number_of_harsh_cornering:
          this.stats.driver_behavior.number_of_harsh_cornering,
      }
      return Object.entries(behaviors)
    },

    driverChanges() {
      return this.stats.driver_behavior.changes || {}
    },

    maintenanceEntries() {
      const maintenance = {
        total_maintenance_cost: this.stats.maintenance.total_maintenance_cost,
        average_cost_per_vehicle:
          this.stats.maintenance.average_cost_per_vehicle,
        total_frequency: this.stats.maintenance.total_frequency,
      }
      return Object.entries(maintenance)
    },

    maintenanceChanges() {
      return this.stats.maintenance.changes || {}
    },
  },

  methods: {
    // Helper method to compare arrays
    arraysEqual(a, b) {
      if (a.length !== b.length) return false
      return a.every((val, index) => val === b[index])
    },

    handleClear() {
      this.selectedRange = '30d'
      this.fetchStats()
    },
    handleRangeSelect(range) {
      this.selectedRange = range
      this.dateRange = null
      this.fetchStats()
    },

    handleCustomRange() {
      if (this.dateRange) {
        this.selectedRange = null
        this.fetchStats()
      }
    },

    vehicleChange(vehicles) {
      const previousCount = this.selectedVehicles.length
      this.selectedVehicles = vehicles
      this.filterForm.company_vehicle.id = vehicles

      if (vehicles.length < previousCount || vehicles.length === 0) {
        this.previousVehicles = [...vehicles]
        this.fetchStats()
      }
    },

    vehicleBlur() {
      // Only fetch if values have actually changed
      if (!this.arraysEqual(this.selectedVehicles, this.previousVehicles)) {
        this.previousVehicles = [...this.selectedVehicles]
        this.fetchStats()
      }
    },

    vehicleClear() {
      this.selectedVehicles = []
      this.previousVehicles = []
      this.filterForm.company_vehicle.id = []
      this.fetchStats()
    },

    tagChanged(tags) {
      const previousCount = this.selectedTags.length
      this.selectedTags = tags
      this.filterForm.company_vehicle_tags = tags

      if (tags.length < previousCount || tags.length === 0) {
        this.previousTags = [...tags]
        this.fetchStats()
      }
    },

    tagBlur() {
      // Only fetch if values have actually changed
      if (!this.arraysEqual(this.selectedTags, this.previousTags)) {
        this.previousTags = [...this.selectedTags]
        this.fetchStats()
      }
    },

    tagClear() {
      this.selectedTags = []
      this.previousTags = []
      this.filterForm.company_vehicle_tags = []
      this.fetchStats()
    },

    organizationChanged(organizations) {
      const previousCount = this.selectedOrganizations.length
      this.selectedOrganizations = organizations
      this.filterForm.organizations = organizations

      if (organizations.length < previousCount || organizations.length === 0) {
        this.previousOrganizations = [...organizations]
        this.fetchStats()
      }
    },

    organizationBlur() {
      // Only fetch if values have actually changed
      if (
        !this.arraysEqual(
          this.selectedOrganizations,
          this.previousOrganizations
        )
      ) {
        this.previousOrganizations = [...this.selectedOrganizations]
        this.fetchStats()
      }
    },

    organizationClear() {
      this.selectedOrganizations = []
      this.previousOrganizations = []
      this.filterForm.organizations = []
      this.fetchStats()
    },

    resetFilters() {
      this.selectedVehicles = []
      this.selectedTags = []
      this.selectedOrganizations = []
      this.previousVehicles = []
      this.previousTags = []
      this.previousOrganizations = []
      this.filterForm.company_vehicle.id = []
      this.filterForm.company_vehicle_tags = []
      this.filterForm.organizations = []
      this.fetchStats()
    },
    fetchStats() {
      this.loading = true
      const params = this.dateRange
        ? {
            start_range: this.dateRange[0],
            stop_range: this.dateRange[1],
          }
        : { range: this.selectedRange }

      if (this.selectedVehicles && this.selectedVehicles.length > 0) {
        params.company_vehicle__vehicle__id__in =
          this.selectedVehicles.join(',')
      }

      if (this.selectedTags && this.selectedTags.length > 0) {
        params.company_vehicle__company_vehicle_tags__id__in =
          this.selectedTags.join(',')
      }

      if (this.selectedOrganizations && this.selectedOrganizations.length > 0) {
        params.company_vehicle__organizations__id__in =
          this.selectedOrganizations.join(',')
      }

      Promise.all([
        StatsReport.api(params),
        FuelsEfficiencies.api(params),
        FleetUtilizations.api(params),
        StatsCosts.api(params),
        StatsFences.api(params),
        StatsDriversBehaviours.api(params),
      ])
        .then(
          ([statsRes, fuelRes, fleetRes, costRes, fenceRes, driversRes]) => {
            if (statsRes) {
              this.stats = statsRes
            }
            if (fuelRes) {
              this.fuelEfficiencyData = fuelRes
            }
            if (fleetRes) {
              this.fleetUtilizationData = fleetRes
            }
            if (costRes) {
              this.costData = costRes
            }
            if (fenceRes) {
              this.fenceEventsData = fenceRes
            }
            if (driversRes) {
              this.driversBehaviorData = driversRes.results
            }

            // Update previous values after successful fetch
            this.previousVehicles = [...this.selectedVehicles]
            this.previousTags = [...this.selectedTags]
            this.previousOrganizations = [...this.selectedOrganizations]

            this.loading = false
          }
        )
        .catch((error) => {
          console.error('Error fetching data:', error)
          this.loading = false
        })
    },
  },
  mounted() {
    this.fetchStats()
  },
}
</script>

<style>
.vpd-main {
  width: fit-content;
}
.vpd-main input {
  font-size: 14px;
  line-height: 20px;
}

.primary__text,
.custom__button:active,
.custom__button:focus {
  font-weight: bold;
  color: rgb(17, 17, 17);
  outline: 0;
}
.default__text {
  font-weight: normal;
  color: rgb(96, 96, 96);
}
.custom__button:hover {
  color: #ff5604;
}
</style>
